// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jz1zt","left":"styles_left__2qfF3","right":"styles_right__3GL8Z","alert":"styles_alert__2JCDV"};